import { useContext, useState } from 'react';
import { BrazeContext, BrazeContextType } from './Context';
import { isDismissed, setDismissed } from './utils';

export const useBraze = (): BrazeContextType => {
  const context = useContext(BrazeContext);

  if (context === undefined) {
    throw Error('BrazeContext must be used inside BrazeProvider scope');
  }

  return context;
};

export const useNotificationPrompt = () => {
  const [isPromptVisible, setIsPromptVisible] = useState(!isDismissed());

  const closePrompt = () => {
    setDismissed(true);
    setIsPromptVisible(false);
  };

  return {
    isPromptVisible,
    closePrompt
  };
};
